import React from 'react';
import Slider from 'react-slick'; // from react-slick
import 'slick-carousel/slick/slick.css'; // slick-core CSS
import 'slick-carousel/slick/slick-theme.css'; // slick-theme CSS
import '../styles/HeroSlider.css'; // Your custom styling

function HeroSlider() {
  // Example slides data
  const slides = [
    {
      image: '/assets/hero/slide1.jpg',
      headline: 'Quality Woodwork.',
      subtext: 'Built-ins and cabinets',
    },
    {
      image: '/assets/hero/slide2.jpg',
      headline: 'Delivering Excellence',
      subtext: 'Cabinets.',
    },
    {
      image: '/assets/hero/slide3.jpg',
      headline: 'Innovate & Inspire',
      subtext: 'Stairs and Trim',
    },
  ];

  // react-slick settings object
  const settings = {
    dots: true,            // Show navigation dots below
    infinite: true,        // Loop through slides
    speed: 500,            // Transition speed
    slidesToShow: 1,       // Show one slide at a time
    slidesToScroll: 1,     // Scroll one slide at a time
    autoplay: true,        // Auto-rotate slides
    autoplaySpeed: 4000,   // Duration between slides
    pauseOnHover: true     // Pause autoplay on hover
    // Add more settings as desired
  };

  return (
    <section className="hero-slider">
      <Slider {...settings}>
        {slides.map((slide, idx) => (
          <div key={idx} className="hero-slide">
            <div
              className="hero-image"
              style={{ backgroundImage: `url(${slide.image})` }}
            >
              {/* Overlay container */}
              <div className="hero-overlay">
                <h1 className="hero-headline">{slide.headline}</h1>
                <p className="hero-subtext">{slide.subtext}</p>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
}

export default HeroSlider;
